import { Place } from "@mui/icons-material";
import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import React from "react";
import { Coordinate } from "rousen-react";

interface Props {
  menu: { x: number; y: number; coords: Coordinate } | null;
  onClose: () => void;
  onChangeMarker: (type: "origin" | "destination", coords: Coordinate) => void;
}

const MapMenu = ({ menu, onClose, onChangeMarker }: Props) => {
  const handleClick = (type: "origin" | "destination") => {
    if (!menu) return;
    onChangeMarker(type, menu.coords);
    onClose();
  };
  return (
    <Menu
      open={Boolean(menu)}
      anchorReference="anchorPosition"
      anchorPosition={menu ? { top: menu.y, left: menu.x } : undefined}
      onClose={onClose}
    >
      <MenuItem onClick={() => handleClick("origin")}>
        <ListItemIcon>
          <Place color="primary" />
        </ListItemIcon>
        <ListItemText primary="Set Origin" />
      </MenuItem>
      <Divider />
      <MenuItem onClick={() => handleClick("destination")}>
        <ListItemIcon>
          <Place color="secondary" />
        </ListItemIcon>
        <ListItemText primary="Set Destination" />
      </MenuItem>
    </Menu>
  );
};

export default MapMenu;
